import { Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";

import { StyledMomentIcon } from "MVVM/Views/MatchHistory/Components/Shared/Match/styledComponents";
import { IQuickEditMoment } from "../@types";

export const Moment = ({
  moment,
  hideTimelineLabel,
  compact,
}: {
  moment: IQuickEditMoment;
  hideTimelineLabel?: boolean;
  compact?: boolean;
}) => {
  if (compact) {
    return (
      <CompactContainer>
        <CompactPlayers>
          <CompactAvatar src={moment.player.avatar} />
          <CompactWeaponIcon src={moment.icons[0]} />
          {moment.victimData.map((victim) => (
            <CompactAvatar key={victim.gameId} src={victim.avatar} />
          ))}
        </CompactPlayers>
        <CompactMomentName>{moment.title}</CompactMomentName>
      </CompactContainer>
    );
  }

  return (
    <Container>
      {!hideTimelineLabel && (
        <Text variant="text.labelXSmall">{moment.timelineLabel}</Text>
      )}
      <Players>
        <HeroAvatar src={moment.player.avatar} />
        <WeaponIcon src={moment.icons[0]} />
        {moment.victimData.map((victim) => (
          <HeroAvatar key={victim.gameId} src={victim.avatar} />
        ))}
      </Players>
      <MomentName>Create {moment.title} Clip</MomentName>
    </Container>
  );
};

const Container = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 12px;
`;

const Players = styled(Flex)`
  align-items: center;
  gap: 10px;
`;

const HeroAvatar = styled(Image)`
  border: 2px solid ${({ theme }) => theme.colors.chalkAlpha40};
  border-radius: 50%;
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  width: 40px;
`;

const WeaponIcon = styled(StyledMomentIcon)`
  flex: unset;
  height: 20px;
  width: auto;
`;

const MomentName = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.6);
`;

const CompactContainer = styled(Flex)`
  align-items: center;
  gap: 8px;
`;

const CompactPlayers = styled(Flex)`
  align-items: center;
  gap: 4px;
`;

const CompactAvatar = styled(Image)`
  border: 1.5px solid ${({ theme }) => theme.colors.chalkAlpha40};
  border-radius: 50%;
  height: 22px;
  min-height: 22px;
  min-width: 22px;
  width: 22px;
`;

const CompactWeaponIcon = styled(StyledMomentIcon)`
  flex: unset;
  height: 12px;
  width: auto;
`;

const CompactMomentName = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
